// extracted by mini-css-extract-plugin
export var general = "button-link-module--general--y9+Sk";
export var primary = "button-link-module--primary--hREF7";
export var secondary = "button-link-module--secondary--pobC8";